import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectorComponent),
    },
  ],
})
export class SelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _originalList = [];
  private _unsubscribe$ = new Subject<void>();

  @Input()
  valueKey = '_id';

  @Input()
  displayKey = 'name';

  @Input()
  label = '';

  @Input()
  hint = '';

  @Input()
  isFlatArray = false;

  @Input()
  hintStyle = '';

  @Input()
  isEmptySelectable: boolean = true;

  @Input()
  isMultiple: boolean = false;

  @Input() set data(list: any[]) {
    if (list) {
      this._originalList = list;
      if (this.isEmptySelectable && this._originalList[0] !== '') {
        this._originalList.unshift('');
      }
      this.searchCtrl.setValue('');
    }
  }

  @Input() loading = false;

  @Input() hideRefreshBtn = false;

  @Output() refreshEvent = new EventEmitter();

  @Output() getNextBatchEvent = new EventEmitter();

  @Output() itemSelected = new EventEmitter();

  ctrl: FormControl = new FormControl();
  searchCtrl: FormControl = new FormControl();
  list = [];
  preSelectedValues = [];

  constructor() {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  writeValue(value: string): void {
    this.ctrl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  ngOnInit(): void {
    this.list = [...this._originalList];
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value) => {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            if (v._id && !this.preSelectedValues.includes(v._id)) {
              this.preSelectedValues.push(v._id);
            }
          });
        }
        this.onChange(value);
        this.itemSelected.emit(value);
      });

    this.searchCtrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((search: string) => {
        if (search) {
          this.list = this._originalList.filter((item: any) => {
            return this.isFlatArray
              ? String(item).toLowerCase().includes(search.toLowerCase())
              : String(item[this.valueKey])
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                  String(item[this.displayKey])
                    .toLowerCase()
                    .includes(search.toLowerCase());
          });
        } else {
          this.list = this._originalList;
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  getNextBatch(): void {
    console.log('load next batch ');
    this.getNextBatchEvent.emit();
  }

  getValue(value: any): void {
    console.log('load next batch: ', value);
  }

  refresh(): void {
    this.loading = true;
    this.refreshEvent.emit();
  }

  onScroll(event: any): void {
    const scrollOffset = event.target.scrollTop;
    const maxOffset = event.target.scrollHeight - event.target.clientHeight;
    if (scrollOffset === maxOffset) {
      // load more data
      // ...
    }
  }
}
